import React from "react"
import { Col, Row } from "reactstrap"
import PropTypes from "prop-types"
import { SaveButton } from "components/Buttons"
import { connect } from "react-redux"
import { updateBulkPublishStatus } from "store/actions"

const BulkUnpublishModal = ({
  handleHideUnpublishModal,
  selectedEvents,
  vendorId,
  updateBulkPublishStatus,
  loading,
}) => {
  return (
    <React.Fragment>
      <Row>
        <h5>
          Are you sure you want to unpublish {selectedEvents?.length}{" "}
          experience(s)?
        </h5>
      </Row>
      <Row>
        <p>
          If you've selected an experience which belongs to multiple categories,
          the changes will be applied globally to that experience.
        </p>
      </Row>
      <Row>
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            color="danger"
            content="Cancel"
            onClick={handleHideUnpublishModal}
          />
        </Col>
        <Col>
          <SaveButton
            content="Unpublish"
            fullWidth={true}
            onClick={() => {
              updateBulkPublishStatus({
                values: {
                  event_ids: selectedEvents,
                  published: false,
                  vendor_id: parseInt(vendorId),
                },
                callback: handleHideUnpublishModal,
              })
            }}
            loading={loading}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

BulkUnpublishModal.propTypes = {
  handleHideUnpublishModal: PropTypes.func,
  loading: PropTypes.bool,
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  updateBulkPublishStatus: values => dispatch(updateBulkPublishStatus(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BulkUnpublishModal)
